var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/jszip/~/core-js/library/modules/_cof.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_cof.js
// module chunks = 3